import {createAutocompletePlugins} from "../autocompletePlugin";
import {createMentionEditPlugin} from "../mentionEditPlugin";
import {mentionSelectionPlugin} from "../mentionSelectionPlugin";

export function createMentionPluginBundle({documentId, hashtagOptions}) {
    const plugins = [];

    plugins.push(createMentionEditPlugin());

    plugins.push(...createAutocompletePlugins({
        docId: documentId,
        hashtagOptions,
    }));


    plugins.push(mentionSelectionPlugin());

    return plugins;
}

